<template>
  <a :href="url" class="__nav_item">
    <font-awesome-icon v-if="icon" :icon="icon" />
    <span :class="{ __text: icon }">
      <slot></slot>
    </span>
  </a>
</template>

<script>
export default {
  name: "NavLink",
  props: {
    url: {
      type: String
    },
    icon: {
      type: Array // Expects: ['fas', 'menu']
    }
  }
};
</script>

<style lang="scss">
@import "../theme.scss";

.__nav_item {
  height: 60px;
  line-height: 60px;
  font-size: 22px;
  padding-left: 25px;
  margin: 15px 0px;
  color: $secondary;
  cursor: pointer;

  .__text {
    padding-left: 15px;
  }

  &:hover {
    color: $primary;
  }
}
</style>
